export const OFFER_PAGE_ASSISTANT_SIDEBAR_WIDTH = 440
export const OFFER_PAGE_ASSISTANT_MIN_SCREEN_SIZE = 'largeDesktop'
export const OFFER_PAGE_ASSISTANT_COLLAPSED_INPUT_BOTTOM_OFFSET = 24
